import { Input, Select, Typography } from "antd";
import GolbalTimezone from "../assets/globe-timezone.svg";
import { TIMEZONES } from "../constants/Constant";

const { Option } = Select;

const AccountSettings = ({ fullName, setFullName, email, timezone, setTimezone }) => (
  <div className="mt-0">
    <div className="grid grid-cols-2 gap-4">
      <div className="text-left">
        <Typography.Text>Full Name</Typography.Text>
        <Input
          placeholder="Enter Name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          className="mt-1"
        />
      </div>
      <div className="text-left">
        <Typography.Text>Email</Typography.Text>
        <Input
          placeholder="Enter Email"
          value={email}
          disabled
          className="mt-1"
        />
      </div>
    </div>
    <div className="mt-4 text-left">
      <Typography.Text>Time Zone</Typography.Text>
      <Select
        showSearch
        className="w-full mt-1"
        placeholder="Select Time Zone"
        value={timezone || undefined}
        onChange={setTimezone} // Update timezone in parent component
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().includes(input.toLowerCase())
        }
        prefix={<img src={GolbalTimezone} alt="Time Zone" className="h-4" />}
      >
        {TIMEZONES.map((tz) => (
          <Option key={tz} value={tz}>{tz}</Option>
        ))}
      </Select>
    </div>
  </div>
);

export default AccountSettings;